/* Uit sections/casanuva-header.liquid gehaald. Draait met defer: na het parsen, dus de elementen
   die deze code opzoekt bestaan gegarandeerd. Alles zit in een IIFE,
   dus er lekt niets naar de global scope. */

(function() {
  'use strict';

  /* ============================================
     DESKTOP: Mega Menu Hover
     ============================================ */
  var navItems = document.querySelectorAll('.cnv-nav-item');
  var closeTimer = null;
  var currentPanel = null;

  function openMega(navItem) {
    // Clear any pending close
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    // Close previously open panel
    if (currentPanel && currentPanel !== navItem) {
      var prevMenu = currentPanel.querySelector('.cnv-mega-menu');
      if (prevMenu) {
        prevMenu.classList.remove('cnv-mega-open');
      }
      currentPanel.classList.remove('cnv-mega-active');
    }

    var mega = navItem.querySelector('.cnv-mega-menu');
    if (mega) {
      mega.classList.add('cnv-mega-open');
      navItem.classList.add('cnv-mega-active');
      currentPanel = navItem;
    }
  }

  function scheduleMegaClose() {
    closeTimer = setTimeout(function() {
      if (currentPanel) {
        var mega = currentPanel.querySelector('.cnv-mega-menu');
        if (mega) {
          mega.classList.remove('cnv-mega-open');
        }
        currentPanel.classList.remove('cnv-mega-active');
        currentPanel = null;
      }
      closeTimer = null;
    }, 200);
  }

  navItems.forEach(function(navItem) {
    navItem.addEventListener('mouseenter', function() {
      openMega(navItem);
    });

    navItem.addEventListener('mouseleave', function() {
      scheduleMegaClose();
    });

    // Keep mega open when hovering the mega menu itself
    var mega = navItem.querySelector('.cnv-mega-menu');
    if (mega) {
      mega.addEventListener('mouseenter', function() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      });

      mega.addEventListener('mouseleave', function() {
        scheduleMegaClose();
      });
    }
  });

  /* ============================================
     MOBILE: Drawer Open / Close
     ============================================ */
  var hamburger = document.getElementById('cnv-hamburger');
  var drawer = document.getElementById('cnv-mobile-drawer');
  var drawerClose = document.getElementById('cnv-drawer-close');
  var drawerL1 = document.getElementById('cnv-drawer-l1');

  if (!hamburger || !drawer) return;

  // overflow:hidden op body alleen is niet genoeg: op mobiel scrollt html, dus
  // de pagina bleef achter de lade doorlopen. Body vastzetten op zijn plek is
  // de enige manier die op iOS werkt; de scrollpositie bewaren we zolang.
  var bewaardeScroll = 0;

  function zetVast() {
    // Al op slot? Dan niets opnieuw meten: window.scrollY is dan 0.
    if (document.body.style.position === 'fixed') return;
    bewaardeScroll = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + bewaardeScroll + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function laatLos() {
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, bewaardeScroll);
  }

  function openDrawer() {
    drawer.classList.add('open');
    hamburger.classList.add('open');
    zetVast();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    hamburger.classList.remove('open');
    laatLos();

    // Reset to Level 1 after transition
    setTimeout(function() {
      resetToLevel1();
    }, 350);
  }

  function resetToLevel1() {
    if (drawerL1) {
      drawerL1.classList.remove('cnv-drawer-slide-out');
    }
    var l2Panels = drawer.querySelectorAll('.cnv-drawer-l2');
    l2Panels.forEach(function(panel) {
      panel.classList.remove('cnv-drawer-l2-open');
    });
  }

  hamburger.addEventListener('click', function() {
    if (drawer.classList.contains('open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (drawerClose) {
    drawerClose.addEventListener('click', closeDrawer);
  }

  /* ============================================
     MOBILE: Level 1 → Level 2 Transitions
     ============================================ */
  var l1Items = drawer.querySelectorAll('.cnv-drawer-l1-item[data-l2-target]');

  l1Items.forEach(function(item) {
    item.addEventListener('click', function() {
      var targetIndex = this.getAttribute('data-l2-target');
      var l2Panel = drawer.querySelector('.cnv-drawer-l2[data-l2-panel="' + targetIndex + '"]');

      if (l2Panel && drawerL1) {
        // Slide Level 1 out left
        drawerL1.classList.add('cnv-drawer-slide-out');
        // Slide Level 2 in from right
        l2Panel.classList.add('cnv-drawer-l2-open');
      }
    });

    // Keyboard accessibility
    item.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  /* ============================================
     MOBILE: Back Buttons
     ============================================ */
  var backButtons = drawer.querySelectorAll('.cnv-drawer-back');

  backButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var l2Panel = this.closest('.cnv-drawer-l2');
      if (l2Panel) {
        l2Panel.classList.remove('cnv-drawer-l2-open');
      }
      if (drawerL1) {
        drawerL1.classList.remove('cnv-drawer-slide-out');
      }

      // Reset pill filters to "All"
      if (l2Panel) {
        var pills = l2Panel.querySelectorAll('.cnv-drawer-pill-tab');
        pills.forEach(function(p) { p.classList.remove('active'); });
        var allPill = l2Panel.querySelector('.cnv-drawer-pill-tab[data-filter="all"]');
        if (allPill) allPill.classList.add('active');

        // Show all links
        var links = l2Panel.querySelectorAll('.cnv-drawer-link');
        links.forEach(function(link) {
          link.classList.remove('cnv-drawer-link-hidden');
        });
      }
    });
  });

  /* ============================================
     MOBILE: Pill Tab Filtering
     ============================================ */
  var pillTabs = drawer.querySelectorAll('.cnv-drawer-pill-tab');

  pillTabs.forEach(function(pill) {
    pill.addEventListener('click', function() {
      var l2Panel = this.closest('.cnv-drawer-l2');
      if (!l2Panel) return;

      var filter = this.getAttribute('data-filter');

      // Update active pill
      var siblings = l2Panel.querySelectorAll('.cnv-drawer-pill-tab');
      siblings.forEach(function(s) { s.classList.remove('active'); });
      this.classList.add('active');

      // Filter links
      var links = l2Panel.querySelectorAll('.cnv-drawer-link');
      links.forEach(function(link) {
        if (filter === 'all') {
          link.classList.remove('cnv-drawer-link-hidden');
        } else {
          var group = link.getAttribute('data-group');
          if (group === filter) {
            link.classList.remove('cnv-drawer-link-hidden');
          } else {
            link.classList.add('cnv-drawer-link-hidden');
          }
        }
      });

      // Overflow pills are always visible — no filtering needed
    });
  });

})();

  /* Land- en taalkiezer: alleen open en dicht. De keuze zelf loopt via echte
     submit-knoppen met hun eigen name en value, dus die werkt ook als dit
     script niet draait. */
  (function () {
    var kiezers = document.querySelectorAll('.cnv-mkt');
    if (!kiezers.length) return;

    function sluitAlles(behalve) {
      kiezers.forEach(function (k) {
        if (k !== behalve) {
          k.removeAttribute('data-open');
          var t = k.querySelector('.cnv-mkt__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    }

    kiezers.forEach(function (k) {
      var trigger = k.querySelector('.cnv-mkt__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = k.hasAttribute('data-open');
        sluitAlles(k);
        if (open) {
          k.removeAttribute('data-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          k.setAttribute('data-open', '');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.cnv-mkt')) sluitAlles(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.cnv-mkt[data-open]');
      if (!open) return;
      sluitAlles(null);
      var t = open.querySelector('.cnv-mkt__trigger');
      if (t) t.focus();
    });
  })();
